module.exports = __webpack_public_path__ + "static/media/peoplemanagement.9b0fd0a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/peoplemanagement.svg
// module id = 156
// module chunks = 0